import { customerTypes } from "./customerTypes";

const initialState = {
  customerOrder: {},
  allCustomerOrder: [],
  meta: {},
  loading: false,
  crudLoading: false,
};

const customer = (state = initialState, action) => {
  switch (action.type) {
    //create order by customer
    case customerTypes.CREATE_ORDER_BY_CUSTOMER_START:
      return {
        ...state,
        crudLoading: true,
      };
    case customerTypes.CREATE_ORDER_BY_CUSTOMER_SUCCESS:
      return {
        ...state,
        allCustomerOrder: action.payload,
      };
    case customerTypes.CREATE_ORDER_BY_CUSTOMER_FAILED:
      return {
        ...state,
        allCustomerOrder: action.payload,
        crudLoading: false,
      };
    case customerTypes.CREATE_ORDER_BY_CUSTOMER_END:
      return {
        ...state,
        crudLoading: false,
      };

    // get all customer order
    case customerTypes.GET_ALL_CUSTOMER_ORDER_START:
      return {
        ...state,
        loading: true,
      };
    case customerTypes.GET_ALL_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        allCustomerOrder: action.payload,
        meta: action.meta,
      };
    case customerTypes.GET_ALL_CUSTOMER_ORDER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case customerTypes.GET_ALL_CUSTOMER_ORDER_END:
      return {
        ...state,
        loading: false,
      };

    // get a customer order
    case customerTypes.GET_A_CUSTOMER_ORDER_START:
      return {
        ...state,
        loading: true,
      };
    case customerTypes.GET_A_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        customerOrder: action.payload,
      };
    case customerTypes.GET_A_CUSTOMER_ORDER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case customerTypes.GET_A_CUSTOMER_ORDER_END:
      return {
        ...state,
        loading: false,
      };

    //update customer order
    case customerTypes.UPDATE_CUSTOMER_ORDER_START:
      return {
        ...state,
        crudLoading: true,
      };
    case customerTypes.UPDATE_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        allCustomerOrder: action.payload,
      };
    case customerTypes.UPDATE_CUSTOMER_ORDER_FAILED:
      return {
        ...state,
        crudLoading: false,
        allCustomerOrder: action.payload,
      };
    case customerTypes.UPDATE_CUSTOMER_ORDER_END:
      return {
        ...state,
        crudLoading: false,
      };

    //delete customer order

    case customerTypes.DELETE_CUSTOMER_ORDER_START:
      return {
        ...state,
        crudLoading: true,
      };
    case customerTypes.DELETE_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        allCustomerOrder: action.payload,
      };
    case customerTypes.DELETE_CUSTOMER_ORDER_FAILED:
      return {
        ...state,
        crudLoading: false,
        allCustomerOrder: action.payload,
      };
    case customerTypes.DELETE_CUSTOMER_ORDER_END:
      return {
        ...state,
        crudLoading: false,
      };

    default:
      return state;
  }
};

export default customer;
